<template>
  <div>
    <CouponsTabs />
    <AlipayCouponsTable project="tn" />
  </div>
</template>

<script>
import AlipayCouponsTable from '@/components/Coupons/AlipayCouponsTable.vue'
import CouponsTabs from '@/components/Coupons/CouponsTabs.vue'

export default {
  components: { AlipayCouponsTable, CouponsTabs }
}
</script>
